import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Brikk } from 'components/Brikk';
import { SearchInput } from 'components/form-elements/inputs/SearchInput';
import { Text } from 'components/typography';
import { PageLoader } from 'components/loaders/PageLoader';
import { useGetGroups } from 'services/2n/groups';
import styles from '../styles.module.scss';
import { useAccessManagement2NModal } from '../AccessManagement2NModalContext/useAccessManagement2NModal';
import { Group } from './components/Group';

export const Groups = () => {
  const [keyword, setKeyword] = useState('');
  const { groups, isLoading } = useGetGroups();
  const intl = useIntl();
  const { updateSelected, updateAdding } = useAccessManagement2NModal();
  // const sortedGroups = groups.sort(
  //   (a, b) => -b.name.localeCompare(a.name),
  // );

  const filteredGroups = !keyword ? groups : groups.filter(
    group => (group.Name).toLowerCase().includes(keyword.toLowerCase()),
  );
  return (
    <div className={styles.container}>
      <Brikk.Heading
        heading="accessGroupsTitle"
      />
      <SearchInput
        placeholder={intl.formatMessage({ id: 'search' })}
        keyword={keyword}
        setKeyword={setKeyword}
      />
      <div className={styles.itemsList}>
        {isLoading && <PageLoader />}
        {!isLoading && filteredGroups && filteredGroups.length > 0 && (
          filteredGroups.map((group, index) => (
            <Group
              key={index}
              group={group}
            />
          ))
        )}
        {!isLoading && (!filteredGroups || filteredGroups.length === 0) && (
          <Text
            secondary
            center
            intl="noGroupsToDisplay"
            size={16}
          />
        )}
      </div>
      <div className={styles.formButtons}>
        <Button
          primary
          onClick={() => {
            updateSelected('group', null);
            updateAdding('group', true);
          }}
        >
          {intl.formatMessage({ id: 'addNewGroup' })}
        </Button>
      </div>
    </div>
  );
};
